module.exports = __webpack_public_path__ + "img/Dekameronen_Sjanger.f8fc2574.jpg";